import { MittwaldIcon as MittwaldIconComponent } from "@mittwald/flow-components/dist/components/MittwaldIcon";
import styled from "styled-components";
export const MittwaldIcon = styled(MittwaldIconComponent) `
  width: 40px !important;
  &.compactMode {
    width: 24px !important;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWl0dHdhbGRJY29uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvSGVhZGVyL3N0eWxlZC9NaXR0d2FsZEljb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFlBQVksSUFBSSxxQkFBcUIsRUFBRSxNQUFNLHdEQUF3RCxDQUFDO0FBQy9HLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBRXZDLE1BQU0sQ0FBQyxNQUFNLFlBQVksR0FBRyxNQUFNLENBQUMscUJBQXFCLENBQUMsQ0FBQTs7Ozs7Q0FLeEQsQ0FBQyJ9